import { render, staticRenderFns } from "./toRegCenter.vue?vue&type=template&id=57f5a948&scoped=true&"
import script from "./toRegCenter.vue?vue&type=script&lang=js&"
export * from "./toRegCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f5a948",
  null
  
)

export default component.exports